// src/App.vue

<template>
  <v-app style="font-family: 'Montserrat';">
    <v-card class="pb-10 accent3" flat color="accent">
      <v-app-bar color="accent" dense fixed class="right" flat>
         <v-app-bar-nav-icon class="grey--text" @click="drawer = !drawer"></v-app-bar-nav-icon>
        <v-toolbar-title class="grey--text">
          <!-- <span class="font-weight-light text-uppercase">QU</span>
          <span class="text-uppercase">BER -->
          <v-flex>
                  <v-img :src="require('@/assets/quberlogo.png')" size="50px"/>
              </v-flex>
          <!-- <span>{{getUserTitle}}</span> -->
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-flex style="max-width:150px; padding-right:10px; padding-top: 5px">
          <v-select
              v-if="authenticated"
              v-model="selectedEnv"
              :items="environments"
              :item-text="
                (item) => item.name
              "
              label="Environment"
              required="!broadcast"
              presistent-hint
              return-object
              v-on:change="changeEnvironment"
            >
          </v-select>
        </v-flex>
        <v-btn text v-for="home in home" :key="home.text" router :to="home.route" color="secondary">
          <v-icon>home</v-icon>
          {{ home.text }}</v-btn>
        <v-btn text id="qsLoginBtn" v-if="!authenticated" @click="login" color="secondary">
          <v-icon>lock_open</v-icon>
          <span>Login</span>
        </v-btn>
        <v-btn text id="qsLogoutBtn" v-if="authenticated" @click="logout" color="secondary">
          <v-icon>lock</v-icon>
          <span>Logout</span>
        </v-btn>
      </v-app-bar>
       <v-navigation-drawer
        v-model="drawer"
        app
        color="primary"
        :disable-resize-watcher=true
        temporary
        left
      >
        <v-list py="0" v-if="authenticated" color="white">
            <v-list-item link>
          <v-list-item-content>
            <v-layout column align-center>
              <v-flex class="mt-5">
                <v-avatar width="170px" height="90px">
                  <v-img :src="getUserPicture ? getUserPicture : require('@/assets/quberlogo.png')"/>
                </v-avatar>
              </v-flex>
            </v-layout>
            <v-list-item-title class="title secondary--text">{{getUserTitle}}</v-list-item-title>
            <v-list-item-subtitle class="secondary--text">{{getUserName}}</v-list-item-subtitle>
          </v-list-item-content>
            </v-list-item>
        </v-list>
        <v-list py="0" v-if="authenticated">
          <v-list-item v-for="link in getAuthorizedLinks" :key="link.text" router :to="link.route">
            <v-list-item-action>
              <v-icon class="white--text">{{ link.icon }}</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title class="white--text">{{ link.text }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <!-- <v-list-group
        value="false"
        prepend-icon="account_balance"
      >
      <v-icon slot="prependIcon" color="white">account_balance</v-icon>
      <v-list-tile slot="activator">
        <v-list-tile-content>
          <v-list-tile-title class="white--text">Aggregators</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
          <v-list-tile
            v-for="agg in aggs"
            :key="agg.text"
            @click=router :to="agg.route"
          >
          <v-list-tile-content>
            <v-list-tile-title class="white--text">{{ agg.text }}</v-list-tile-title>
          </v-list-tile-content>
          </v-list-tile>
        </v-list-group> -->
         </v-list>
      </v-navigation-drawer>
    </v-card>
    <div class="container">
      <router-view
        :auth="auth"
        :authenticated="authenticated"
        :admin="admin"
        :paymentAdmin="paymentAdmin"
        :vendorAdmin="vendorAdmin"
      ></router-view>
      <v-dialog v-if="authenticated" v-model="showEnvDialog" max-width="400px">
        <v-card  width="380px">
          <v-card-title>Select Environment</v-card-title>
          <template>
            <v-layout column align-center>
                <v-flex class="mt-5">
                  <v-select
                    v-model="selectedEnv"
                    :items="environments"
                    :item-text="
                      (item) => item.name
                    "
                    label="Environment"
                    required="!broadcast"
                    width="30px"
                    presistent-hint
                    return-object
                    v-on:change="changeEnvironment"
                  >
                </v-select>
                </v-flex>
            </v-layout>
        </template>
        </v-card>
      </v-dialog>
    </div>
    <v-bottom-navigation height="28" dense fixed class="left" flat>
      <v-row align="end" justify="end"><h6 class="pb-4 pr-5 black--text">{{appVersion}}</h6></v-row>
    </v-bottom-navigation>
  </v-app>
</template>
<script>
import auth from '@/components/Auth/AuthService'
import { version } from '../package'

export default {
  name: 'app',
  data () {
    return {
      auth,
      appVersion: version,
      authenticated: auth.authenticated,
      admin: auth.admin,
      paymentAdmin: auth.paymentAdmin,
      vendorAdmin: auth.vendorAdmin,
      drawer: false,
      image: '@/assets/logo.png',
      home: [
        { text: 'Home', route: '/' }
      ],
      links: [
        { icon: 'account_circle', text: 'Profile', route: '/profile', roles: ['admin', 'user'] },
        { icon: 'email', text: 'Notifications', route: '/notifications', roles: ['admin'] },
        { icon: 'group', text: 'Users', route: '/users', roles: ['admin'] },
        { icon: 'group', text: 'User Verify', route: '/userverify', roles: ['admin'] },
        { icon: 'email', text: 'Messages', route: '/messages', roles: ['admin'] },
        { icon: 'credit_card', text: 'Payment Admin', route: '/payment-admin', roles: ['admin'] },
        { icon: 'loyalty', text: 'Vendor Admin', route: '/vendor-admin', roles: ['admin'] },
        { icon: 'block', text: 'Blacklist', route: '/blacklist', roles: ['admin'] },
        { icon: 'collections', text: 'Cards', route: '/cards', roles: ['admin'] },
        { icon: 'ballot', text: 'Contests', route: '/contests', roles: ['admin'] },
        { icon: 'account_balance', text: 'Budget', route: '/budget', roles: ['admin'] },
        { icon: 'add_box', text: 'Challenges', route: '/challenges', roles: ['admin'] },
        { icon: 'account_balance', text: 'Aggregators', route: '/fis', roles: ['admin'] },
        { icon: 'question_answer', text: 'Questionnaire', route: '/questionnairev2', roles: ['admin'] },
        { icon: 'group', text: 'Groups', route: '/groups', roles: ['admin'] },
        { icon: 'text_snippet', text: 'Reports', route: '/reports', roles: ['admin'] }
      ],
      selectedEnv: { },
      environments: [
        { code: 'CA', name: 'Canada' },
        { code: 'US', name: 'US' }
      ],
      showEnvDialog: false
    }
  },
  methods: {
    login () {
      auth.login()
    },
    logout () {
      auth.logout()
    },
    changeEnvironment: function () {
      sessionStorage.removeItem('questionnaires')
      sessionStorage.removeItem('users')
      sessionStorage.setItem('selectedEnv', JSON.stringify(this.selectedEnv))
      this.showEnvDialog = false
      if (this.$route.name !== 'home') {
        this.$router.push('/')
      }
    }

  },
  created () {
    auth.authNotifier.on('authChange', authState => {
      this.authenticated = authState.authenticated
      this.admin = authState.admin
      this.paymentAdmin = authState.paymentAdmin
      this.vendorAdmin = authState.vendorAdmin
    })
    auth.renewSession()
  },
  mounted () {
    if (
      sessionStorage.getItem('selectedEnv') === undefined ||
      sessionStorage.getItem('selectedEnv') === null
    ) {
      this.showEnvDialog = true
    } else {
      this.selectedEnv = JSON.parse(sessionStorage.getItem('selectedEnv'))
    }
    // if (!auth.authenticated) {
    //   auth.login()
    // }
  },
  computed: {
    getAuthorizedLinks () {
      var filtered = this.links.filter(function (obj) {
        return auth.hasAnyRole(obj.roles)
      })
      return filtered
    },
    getUserTitle () {
      if (auth.getQuberUser()) {
        return auth.getQuberUser().firstName + ' ' + auth.getQuberUser().lastName
      } else {
        return ''
      }
    },
    getUserPicture () {
      // if (auth && auth.getUserProfile() && auth.getUserProfile().picture) {
      //   return auth.getUserProfile().picture
      // } else {
      return null
    // }
    },
    getUserName () {
      if (auth.getQuberUser()) {
        return auth.getQuberUser().quberUserName
      } else {
        return ''
      }
    }
  }
}
</script>

<style src="./styles/quberstyles.css">
v-overlay {
  position: relative !important;
}
</style>
